import { render, staticRenderFns } from "./ListNohinsaki.vue?vue&type=template&id=172c1771&"
import script from "./ListNohinsaki.vue?vue&type=script&lang=ts&"
export * from "./ListNohinsaki.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports